import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../shared/common/common.service';
import { AuthService } from '../auth.service';
import { Roles } from '../roles.enum';
import { JwtUtils } from '../utilities/jwtUtils';

@Injectable()
export class RolesGuard implements CanActivate, CanActivateChild {

  constructor(
    private authService: AuthService,
    private commonService: CommonService,
    private toastrService: ToastrService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      if (route.data.excludeRoles && route.data.excludeRoles.length > 0) {
        for(const role of route.data.excludeRoles) {
          if (JwtUtils.hasRoleByName(role)) {
            this.commonService.showLoader(false);
            this.toastrService.error("You are not authorized to access this page.\n\nPlease contact IT for additional information.", "Unauthorized");
            return false;
          };
        }
      }
      if (!route.data.roles || route.data.roles.length === 0) {
          return true;
      }

      for (const role of route.data.roles) {
        if (JwtUtils.hasRoleByName(role)) {
          return true;
        };
      }

      this.commonService.showLoader(false);
      this.toastrService.error("You are not authorized to access this page.\n\nPlease contact IT for additional information.", "Unauthorized");

      return false;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      if (!route.data.roles || route.data.roles.length === 0) {
        return true;
      }

      for (const role of route.data.roles) {
        if (JwtUtils.hasRoleByName(role)) {
          return true;
        };
      }

      this.commonService.showLoader(false);
      this.toastrService.error("You are not authorized to access this page.\n\nPlease contact IT for additional information.", "Unauthorized");

      return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/auth/guards/roles-guard.service.ts